/**
 * API client for the current user's /me endpoint.
 * Routes: /api/mgmt/me
 */

import { apiFetch } from './client';

export interface MeProfile {
  username: string;
  email: string;
  displayName: string;
  role: 'user' | 'admin';
  status: 'active' | 'disabled';
  maxBudget?: number;
  createdAt: string;
  updatedAt: string;
}

export interface UserSpend {
  totalSpend: number;
  totalTokens: number;
  totalRequests: number;
  dailySpend: { date: string; spend: number }[];
}

export interface MeResponse {
  userId: string;
  email: string;
  profile: MeProfile | null;
  spend: Record<string, unknown>;
  userSpend?: UserSpend;
}

export async function getMe(token: string): Promise<MeResponse> {
  return apiFetch<MeResponse>('/api/mgmt/me', token);
}
